import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { BaseFilter, FilterByCodes, instanceOfFilterByCodes } from '../models';

/** Returns a BaseFilter as a FilterByCodes, or undefined if it is not. */
@Pipe({
  name: 'coerceFilterByCodes',
})
export class CoerceFilterByCodesPipe implements PipeTransform {
  transform<V extends Variable | VariableSummary>(filter: BaseFilter<V> | null | undefined): FilterByCodes<V> | undefined {
    return instanceOfFilterByCodes(filter) ? filter : undefined;
  }
}

@NgModule({
  exports: [CoerceFilterByCodesPipe],
  declarations: [CoerceFilterByCodesPipe],
})
export class CoerceFilterByCodesPipeModule {}
